var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"timeline",staticClass:"audio-timeline",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"timeline__track"},[_c('div',{ref:"playhead",staticClass:"timeline__playhead"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }